import { connect } from 'react-redux';
import { ConnectedRouter } from '@jauntin/react-ui';
import RouteParser from '../Helpers/RouteParser';
import EventSelectSecondary from '../Components/EventSelectSecondary/EventSelectSecondary';
import { emptyEventType } from '../Constants/eventTypes';

const mapStateToProps = (state) => ({
  show: state.formPage.formPage === RouteParser.formParts.eventQuestions,
  valid: state.formPage.eventSelectSecondary.valid,
  eventType: state.formPage.eventType.selection || emptyEventType,
  showAlert: state.formPage.eventSelectSecondary.showAlert,
  currentLocation: state.router.location.pathname,
});

const mapDispatchToProps = (dispatch) => ({
  confirm: (location) =>
    dispatch(
      ConnectedRouter.push(
        RouteParser.create(location).linkToApplicationPage(),
      ),
    ),
  back: () =>
    dispatch(ConnectedRouter.push(new RouteParser().linkToEventTypePage())),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  confirm: () => dispatchProps.confirm(stateProps.currentLocation),
});

const EventSelectSecondaryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(EventSelectSecondary);

export default EventSelectSecondaryContainer;
